// Centralized URL links for images and external resources

import klayderLogoBlack from './klayder-logo-black.svg'
import klayderSymbol from './klayder-symbol.svg'

// Helper to generate Cloudinary URLs
const cloudinaryUrl = (id: string) =>
  `https://res.cloudinary.com/dow7tumxl/image/upload/w_auto,dpr_auto,q_auto:best,f_auto/${id}`

export const IMAGE_URLS = {
  // Hero Section
  hero: {
    background:
      'https://p58.f1.n0.cdn.zight.com/items/WnuP96Ae/04f1fccc-af9a-434b-9459-4e3a9c4224db.jpeg?v=a4c23830403c36333185774954e7a173',
    howItWorks:
      'https://p58.f1.n0.cdn.zight.com/items/OAueyE6G/000706c3-db21-43b2-814b-e682d44afa44.jpeg?v=6c4dfa9ce28a07f99e074e4c37e84ff5',
    accountBackground:
      'https://www.metoffice.gov.uk/binaries/content/gallery/metofficegovuk/hero-images/weather/winter/benches-in-snow-covered-woods.jpg',
  },

  // Partner/Brand Logos
  logos: {
    ica: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/ICA_logo.svg/1280px-ICA_logo.svg.png',
    onomi:
      'https://cdn.prod.website-files.com/68b6ea19ac0a61cd114aa0f7/68b6ea19ac0a61cd114aa1c1_de0afe6c42d3bb0c33650c95ca58bf10_onomi-logo-final%20%281%29.svg',
    rift: 'https://cdn.prod.website-files.com/691c5857fd58cfa423a719e0/691c5857fd58cfa423a71a34_rift-logo.png',
    spotify:
      'https://storage.googleapis.com/pr-newsroom-wp/1/2023/05/Spotify_Primary_Logo_RGB_Green.png',
    aceternity: 'https://assets.aceternity.com/logo-dark.png',
    klayder: klayderLogoBlack,
    klayderSymbol: klayderSymbol,
    luminar: cloudinaryUrl('luminar_nbgtym'),
  },

  // Icons
  icons: {
    arrow: cloudinaryUrl('arrow_pyztze'),
  },

  images: {
    asurgent: cloudinaryUrl('alexander_ashman_rea5hn'),
    tshirt: cloudinaryUrl('white-shirt_ftmvjv'),
    hoodie: cloudinaryUrl('black-hoodie_uztpnd'),
    teamKit: cloudinaryUrl('team-kit_oyhuad'),
  },

  // How It Works Section Images
  howItWorks: {
    image1: cloudinaryUrl('1_uccfdk'),
    image2: cloudinaryUrl('2_uaa78l'),
    image3: cloudinaryUrl('3_kkdc7w'),
    image4: cloudinaryUrl('4_ntkugc'),
    image5: cloudinaryUrl('5_hva836'),
    image6: cloudinaryUrl('6_tbcjll'),
    image11: cloudinaryUrl('11_ysp5p9'),
    image12: cloudinaryUrl('12_fdnfpd'),
    image13: cloudinaryUrl('13_oahfwy'),
    image14: cloudinaryUrl('14_thyagr'),
    image15: cloudinaryUrl('15_devxek'),
    image16: cloudinaryUrl('16_nmfocr'),
    image17: cloudinaryUrl('17_djtkna'),
    image18: cloudinaryUrl('18_wexqdw'),
    image21: cloudinaryUrl('21_tkqupf'),
    image22: cloudinaryUrl('22_sslekp'),
    image23: cloudinaryUrl('23_gyutpa'),
    image24: cloudinaryUrl('24_bfxn6g'),
    image25: cloudinaryUrl('25_rxkmu1'),
    image26: cloudinaryUrl('26_xslwik'),
    image27: cloudinaryUrl('27_ur6stg'),
    image28: cloudinaryUrl('28_didsij'),
  },

  // Flags
  flags: {
    gb: 'https://flagcdn.com/gb.svg',
  },

  // Carmelo/Support Avatar
  avatar: {
    carmelo:
      'https://i.ibb.co/nqGYMRJ8/a4047548-c025-49cb-8953-9f42fc35763e.png',
  },

  // About Page
  about: {
    abstractWaves:
      'https://img.freepik.com/premium-photo/abstract-background-with-colorful-waves_961875-152104.jpg?semt=ais_hybrid&w=740&q=80',
    production: 'https://lynka.eu/media/wysiwyg/DSC_1246.jpg',
    nature:
      'https://s1.travix.com/blog/eu/europe-portugal-azores-sete-cidades-path-medium.jpg',
  },

  // Product Gallery
  products: {
    tshirt:
      'https://geomgftprgkqgktskngb.supabase.co/storage/v1/object/public/product-images/l/SA_STSU202_C002.jpg',
    neutral:
      'https://neutral.com/cdn/shop/products/1_fd911ba2-724e-428c-8260-cd49fbc9df0c_1024x1024.jpg?v=1740046916',
    shorts: 'https://pim.headwear.se/images/thumbs/0007841_badshorts-rpet.png',
    mug: 'https://cdn1.midocean.com/image/700X700/kc1464-03.jpg',
    hoodie:
      'https://geomgftprgkqgktskngb.supabase.co/storage/v1/object/public/product-images/l/BC_WU31B_882.jpg',
    main: 'https://geomgftprgkqgktskngb.supabase.co/storage/v1/object/public/product-images/l/SA_STSU177_MAIN.jpg',
  },

  // Design/Illustration
  designs: {
    default:
      'https://geomgftprgkqgktskngb.supabase.co/storage/v1/object/public/illustration-logos/6bd4b18f-ea5d-4a96-bc41-31d3088e3732/0.2624280294768918.png',
  },

  // Print Techniques
  printTechniques: {
    screenTransfer: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/screen-transfer/screen-transfer_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/screen-transfer/screen-transfer_3.png',
    ],
    engravedPatch: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/engraved-patch/engraved-patch_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/engraved-patch/engraved-patch_3.png',
    ],
    digitalPrinting: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/digital%20printing/digital-printing_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/digital%20printing/digital-printing_3.png',
      'https://lynka.eu/media/wysiwyg/digital_printing-big.jpg',
    ],
    digitalTransfer: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/digital-transfer/digital-transfer_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/digital-transfer/digital-transfer_3.png',
      'https://lynka.eu/media/wysiwyg/14_1.jpg',
    ],
    embroidery: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/embroidery/embroidery_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/embroidery/embroidery_3.png',
      'https://lynka.eu/media/wysiwyg/DSC02597.jpg',
    ],
    puLabel: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/pu-label/pu-label_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/pu-label/pu-label_3.png',
    ],
    printedPatchEmbroidered: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/printed-patch-with-embroidered-outline/printed-patch%20with-embroidered-outline_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/printed-patch-with-embroidered-outline/printed-patch%20with-embroidered-outline_3.png',
    ],
    embroidery3d: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/3d-embroidery/3d-embroidery_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/3d-embroidery/3d-embroidery_3.png',
    ],
    digitalRound360: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/digital-round-360/digital-round-360_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/digital-round-360/digital-round-360_3.png',
    ],
    silkScreen: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/silk-screen/silk-screen_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/silk-screen/silk-screen_3.png',
    ],
    silkScreenRound: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/silk-screen-round/silk-screen-round_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/silk-screen-round/silk-screen-round_3.png',
    ],
    laserEngraving:
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/laser-engraving/laser-engraving_.png',
    laserEngraving360: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/laser-engraving-360/laser-engraving-360_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/laser-engraving-360/laser-engraving-360_3.png',
    ],
    co2Engraving:
      'https://www.xdconnects.com/content/files/images/webpages/decoration/decoration-techniques/decoration_co2-engraving.jpg',
    padPrint: [
      'https://www.xdconnects.com/content/files/images/webpages/decoration/decoration-techniques/pad-print/padprint_.jpg',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/pad-print/pad-print_3.png',
    ],
    doming: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/doming/doming_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/doming/doming_3.png',
    ],
    hotStamping: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/hot%20stamping/hot-stamping_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/hot%20stamping/hot-stamping_3.png',
    ],
    hotFoilStamping: [
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/hot-foil-stamping/hot-foil-stamping_.png',
      'https://www.xdconnects.com/images/1024/images/webpages/decoration/decoration-techniques/hot-foil-stamping/hot-foil-stamping_3.png',
    ],
    // Lynka techniques
    plastisol: 'https://lynka.eu/media/wysiwyg/plastisol2-big.jpg',
    waterBased: 'https://lynka.eu/media/wysiwyg/water_based2.jpg',
    hd: 'https://lynka.eu/media/wysiwyg/hd.jpg',
    highDensity: 'https://lynka.eu/media/wysiwyg/Untitled-14.jpg',
    gel: 'https://lynka.eu/media/wysiwyg/Gel.jpg',
    jets: 'https://lynka.eu/media/wysiwyg/jets_2-big.jpg',
    metallicFlexFoil: 'https://lynka.eu/media/wysiwyg/metallic_flex_foil.jpg',
    glitter: 'https://lynka.eu/media/wysiwyg/Glitter.jpg',
    metallicGold: 'https://lynka.eu/media/wysiwyg/metallic_gold.jpg',
    silverShimmer: 'https://lynka.eu/media/wysiwyg/Silver_Shimmer.jpg',
    textureEffect1: 'https://lynka.eu/media/wysiwyg/IMG_2094.jpg',
    textureEffect2: 'https://lynka.eu/media/wysiwyg/IMG_2191.jpg',
    pearl: 'https://lynka.eu/media/wysiwyg/pearl_1.jpg',
    puff: 'https://lynka.eu/media/wysiwyg/puff3.jpg',
    spongePuff: 'https://lynka.eu/media/wysiwyg/Sponge_puff.jpg',
    leatherEffect: 'https://lynka.eu/media/wysiwyg/Leather_Effect.jpg',
    textureEffect3: 'https://lynka.eu/media/wysiwyg/IMG_2200.jpg',
    glowInTheDark: 'https://lynka.eu/media/wysiwyg/Glow_in_the_dark_1.jpg',
    discharge: 'https://lynka.eu/media/wysiwyg/Untitled-15.jpg',
    uvGlowInk: 'https://lynka.eu/media/wysiwyg/UV_Glow_Ink.jpg',
    openworkEmbroidery:
      'https://lynka.eu/media/wysiwyg/Openwork_Embroidery.jpg',
    mixedThreads: 'https://lynka.eu/media/wysiwyg/Mixed_Threads.jpg',
    metallicThreads: 'https://lynka.eu/media/wysiwyg/Metallic_Threads.jpg',
    neonThreads: 'https://lynka.eu/media/wysiwyg/Neon_Threads.jpg',
    glowInTheDarkThreads:
      'https://lynka.eu/media/wysiwyg/Glow_in_the_Dark_Threads.jpg',
    shadedThreads: 'https://lynka.eu/media/wysiwyg/Shaded_Threads.jpg',
    complexFillEmbroidery:
      'https://lynka.eu/media/wysiwyg/Complex_Fill_Embroidery.jpg',
    embroidery3dLynka: 'https://lynka.eu/media/wysiwyg/3D_Embroidery.jpg',
    topStitch: 'https://lynka.eu/media/wysiwyg/Top_Stitch.jpg',
    multiColoredThreads:
      'https://lynka.eu/media/wysiwyg/Multi-Colored_Threads.jpg',
    embroideryApplique:
      'https://lynka.eu/media/wysiwyg/Embroidery_Appliqu_.jpg',
    directPrint: 'https://lynka.eu/media/wysiwyg/direct-print.jpg',
    embroideryGeneric: 'https://lynka.eu/media/wysiwyg/embroiudery.jpg',
    flockTransfer: 'https://lynka.eu/media/wysiwyg/flock-transfer.jpg',
    printedPatch: 'https://lynka.eu/media/wysiwyg/printed-patch.jpg',
    transfer: 'https://lynka.eu/media/wysiwyg/transfer.jpg',
    wovenApplique: 'https://lynka.eu/media/wysiwyg/woven-applique.jpg',
    wovenLabel: 'https://lynka.eu/media/wysiwyg/woven-label.jpg',
    sublimation: 'https://lynka.eu/media/wysiwyg/Untitled-6.jpg',
  },
} as const
